import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { noop } from '../../../../utils/utils';

export default class CampaignExternalLinkAddress extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    required: PropTypes.bool,
  };

  static defaultProps = {
    value: '',
    onChange: noop,
    required: false,
  };

  render() {
    return (
      <TextField
        id="ctaAddressInput"
        label="Address"
        value={this.props.value}
        onChange={this.props.onChange}
        margin="normal"
        type="url"
        placeholder="https://"
        inputProps={{ maxLength: '256' }}
        fullWidth
        required={this.props.required}
      />
    );
  }
}
